import { atom } from "recoil";

export const uploadMultipleState = atom({
  key: "uploadMultipleState",
  default: {
    parameter_json: true,
    aero_coefficients_1: true,
    aero_coefficients_2: true,
    wind_model: true,
    thrust_profile: true,
  },
});
